import checkAuthenticated from "@/router/middlewares/checkAuthenticated";
import beforeEnterCheck from "@/router/middlewares/beforeEnterCheck";
import DECORATION_TYPES from '@/router/enums/DECORATION_TYPES';

export default [
    {
        path: '/absentReport',
        name: 'AbsentOverview',
        component: () => import(/* webpackChunkName: "absentOverview" */ '@/modules/reports/absentoverview/AbsentOverview'),
        meta: {
            moduleId: 'absentOverview',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/reports/absentevaluation',
        name: 'absentReport',
        component: () => import(/* webpackChunkName: "absentReport" */ '@/modules/reports/absentreport/AbsentReport'),
        meta: {
            moduleId: 'absentReport',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/reports/attendanceOverview',
        name: 'attendanceOverview',
        component: () => import(/* webpackChunkName: 'attendanceReport' */ '@/modules/reports/attendanceoverview/AttendanceOverview'),
        meta: {
            moduleId: 'attendanceOverview',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/reports/monthly-hours',
        name: 'employeeReport',
        component: () => import(/* webpackChunkName: "employeeReport" */ '@/modules/reports/monthlyhours/EmployeeReport'),
        meta: {
            moduleId: 'employeeReport',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/reports/monthly-occ-group',
        name: 'occReport',
        component: () => import(/* webpackChunkName: "occReport" */ '@/modules/reports/monthlyhours/OccReport'),
        meta: {
            moduleId: 'occGroupReport',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/reports/anniversaryreport',
        name: 'AnniversaryView',
        component: () => import(/* webpackChunkName: "anniversaryView" */ '@/modules/reports/anniversary/AnniversaryView'),
        meta: {
            moduleId: 'anniversary',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/reports/stock',
        name: 'StockReport',
        component: () => import(/* webpackChunkName: "stockReport" */ '@/modules/reports/stock/StockReport'),
        meta: {
            moduleId: 'stockReport',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/reports/commissions',
        name: 'CommissionReport',
        component: () => import(/* webpackChunkName: "commissionReport" */ '../../src/modules/reports/commission/CommissionReport'),
        meta: {
            moduleId: 'commissionReport',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        props: true,
        beforeEnter: checkAuthenticated
    },
    {
        path: '/reports/protocols',
        name: 'ProtocolReport',
        component: () => import(/* webpackChunkName: "protocolReport" */ '@/modules/reports/protocol/ProtocolReport'),
        meta: {
            moduleId: 'protocolReport',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated
    },
    {
        path: '/reports/project-budget',
        name: 'projectBudgetReport',
        component: () => import(/* webpackChunkName: "projectBudgetReport" */ '@/modules/reports/projectbudget/ProjectBudgetReport'),
        meta: {
            moduleId: 'projectBudgetReport',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
            preloads: ['rights/actingUserHasRight/WORK_Auswertung_BudgetReport'],
        },
        props: true,
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/reports/project-budget/:id',
        name: 'ProjectBudgetForm',
        component: () => import(/* webpackChunkName: "project-budget-form" */ '@/modules/reports/projectbudget/ProjectBudgetForm'),
        meta: {
            moduleId: 'projectBudgetReport',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        props: true,
        beforeEnter: beforeEnterCheck,
    },
    {
        path: '/reports/sales-statistics',
        name: 'SalesStatisticsReport',
        component: () => import(/* webpackChunkName: "sales-statistics" */ '@/modules/reports/salesstatistics/SalesStatisticsReport'),
        meta: {
            moduleId: 'salesStatisticsReport',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/reports/employee-hours-report',
        name: 'ProjectHoursReport',
        component: () => import(/* webpackChunkName: "project-hours" */ '@/modules/reports/projecthours/ProjectHoursReport'),
        meta: {
            moduleId: 'projecthoursReport',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated,
    },
    {
        path: '/reports/balance-report',
        name: 'BalanceReport',
        component: () => import(/* webpackChunkName: "balance-report" */ '@/modules/reports/balance/BalanceReport'),
        meta: {
            moduleId: 'balanceReport',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated,
    },
    {
        path: "/reports/balancechange",
        name: "BalanceChangeReport",
        component: () => import(/* webpackChunkName: "balanceChangeReport" */ '@/modules/reports/balance/BalanceChangeReport'),
        meta: {
            moduleId: 'balanceChangeReport',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated,
    },
    {
        path: "/reports/weekend-official-holiday",
        name: "WeekendOfficialHolidayReport",
        component: () => import(/* webpackChunkName: "weekendOfficialHolidayReport" */ '@/modules/reports/weekend_official_holiday/WeekendOfficialHolidayReport'),
        meta: {
            moduleId: 'weekendOfficialHolidayReport',
            decorations: [DECORATION_TYPES.GENERATE_TABLE_CACHE_ID],
        },
        beforeEnter: checkAuthenticated,
    },
]
